import { Component,  Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { InformableSection } from 'globals/store/informables.data';
import { publicHelpers } from '../../helpers/public-helpers';
import { MatDialog } from '@angular/material/dialog';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { InformableDialogComponent, InformableEditInfo } from 'src/app/components/informable/informable.dialog.component';
import { InformationComponent } from 'src/app/components/information/information.component';
import { createId } from 'globals/helpers/helpers';

@Component({
    selector: 'editable-notes',
    template: `
<information
  [allCollapse]="initClosed"
  [information]="notes"
  [readOnly]="readOnly"
  [noPadding]="noPadding"
  [noItemsMessage]="noItemsMessage"
  [singleSectionOnly]="true"
  [namePlaceholderOverride]="'Title'"
  [descriptionPlaceholderOverride]="'Notes'"
  (addItem)="addASection()"
  (openItem)="openItem($event)"
  (dropItem)="dropItem($event)"
></information>
`,
    styleUrls: ['editable-notes.scss'],
    standalone: true,
    imports: [InformationComponent]
})
export class EditableNotesComponent implements OnChanges {
  @Input() notes: InformableSection[]
  @Input() noItemsMessage = 'No notes'
  @Input() readOnly = true
  @Input() initClosed = true
  @Input() noPadding = false
  @Output() onChanges: EventEmitter<null> = new EventEmitter();

  idInWaiting:string;
  newIds: Set<string> = new Set()
  helpers = publicHelpers
  constructor(
    private dialog: MatDialog,
  ) {
    
  }

  // add change detections, look for new notes if id matches, open dialog
  ngOnChanges(change){
    if(this.idInWaiting && change.notes.currentValue && change.notes.currentValue[0].items){
      const openNewItem = change.notes.currentValue[0].items.find(item=>item.id === this.idInWaiting)
      if(openNewItem){
        this.idInWaiting = null
        setTimeout(()=>this.openItem({item:openNewItem, info:change.notes.currentValue[0]}), 500)
      }
    }
  }

  openItem({item, info}) {
    const data: InformableEditInfo = { item, sectionId: info.id, information:this.notes, notInformable: true, itemPlaceholder: 'Title', descriptionPlaceholder: 'Notes' }
    openDialogGetResult(this.dialog, InformableDialogComponent, { width: '480px', disableClose: true, data }).then(changed => { 
      return changed && this.onChanges.emit()
    })
  }

  dropItem(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
    this.onChanges.emit();
  }

  addASection() {
    const id = createId()
    this.newIds.add(id)
    this.idInWaiting = id;
    this.notes[0].items.push({ id, name: "", description: "", placeholder: "", files: []} )
    this.onChanges.emit();
  }
}


